export {
  default,
}
  from './retailer-new.vue'
